import { type BadgeVariant } from '@/features/missions/components/MissionBadge'
import { msg } from '@lingui/core/macro'
import { useLingui } from '@lingui/react/macro'
import clsx from 'clsx'
import type { PayoutStatus } from '../api/models'

const STATUS_CONFIG: Record<PayoutStatus, { label: ReturnType<typeof msg>; variant: BadgeVariant }> = {
  REQUESTED: { label: msg`Requested`, variant: 'warning' },
  PROCESSING: { label: msg`Processing`, variant: 'warning' },
  COMPLETED: { label: msg`Completed`, variant: 'success' },
  FAILED: { label: msg`Failed`, variant: 'error' },
  CANCELLED: { label: msg`Cancelled`, variant: 'default' }
}

type PayoutStatusBadgeProps = {
  status: PayoutStatus
}

export const PayoutStatusBadge = ({ status }: PayoutStatusBadgeProps) => {
  const { t } = useLingui()
  const { label, variant } = STATUS_CONFIG[status]

  const variantClass = {
    success: 'text-green border-green/20',
    yellow: 'text-yellow border-yellow/20',
    warning: 'text-[var(--colorOrange)] border-[color:var(--colorOrange)]/20',
    error: 'text-[var(--colorError)] border-[color:var(--colorError)]/20',
    default: 'text-[var(--colorGray80to90)] border-[color:var(--colorGray80to90)]/20'
  }[variant ?? 'default']

  return (
    <div className={clsx('flex items-center gap-2 rounded-lg border border-solid p-1 whitespace-nowrap', variantClass)}>
      <div className="text-body-3 flex items-center gap-1">{t(label)}</div>
    </div>
  )
}
